import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import user1 from "../../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../../utils/ImageViewingAPI";

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Manrope",
    color: "#333",
  },

  header: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 8,
    marginBottom: 14,
  },

  subHeader: {
    textAlign: "center",
    fontSize: 12,
    marginBottom: 15,
  },

  row: {
    flexDirection: "row",
  },

  leftImage: {
    width: "35%",
    alignItems: "center",
    marginBottom: 14,
  },

  profileImage: {
    width: 140,
    height: 140,
    objectFit: "cover",
    border: "1px solid #ccc",
  },

  rightInfo: {
    width: "65%",
    paddingLeft: 10,
  },

  infoRow: {
    flexDirection: "row",
    marginBottom: 4,
  },

  label: {
    width: 80,
    fontSize: 9,
    color: "#555",
  },

  value: {
    fontSize: 9,
    fontWeight: "bold",
  },

  divider: {
    borderBottomWidth: 1,
    borderColor: "#999",
    marginVertical: 8,
  },

  sectionTitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 5,
  },

  footer: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    textAlign: "center",
    fontSize: 8,
    color: "grey",
  },
});

const EditEmpDocument = ({ employeeData }) => {
  const [profileImg, setProfileImg] = useState(user1);

  console.log("employeeData:", employeeData);

  useEffect(() => {
    const loadImage = async () => {
      if (employeeData?.imagepath) {
        const img = await fetchProfilePic(employeeData.imagepath);
        setProfileImg(img);
      }
    };

    loadImage();
  }, [employeeData]);

  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );

  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  const d = employeeData || {};

  const formatDate = (date) => (date ? dayjs(date).format("DD-MMM-YYYY") : "-");

  const fetchProfilePic = async (path) => {
    if (!path) return user1;

    const fileName = path.replace(/\\/g, "/").split("/").pop();
    const url = `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;

    try {
      const res = await fetch(url, {
        mode: "cors", // important
      });

      if (!res.ok) throw new Error("Failed to fetch image");

      const blob = await res.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // ✅ base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Image load failed:", err);
      return user1;
    }
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER IMAGE */}
        {headerImage && (
          <Image src={headerImage} style={{ width: "100%", height: 60 }} />
        )}

        {/* TITLE */}
        <Text style={styles.header}>Employee Report</Text>

        {/* MAIN SECTION */}
        <View style={styles.row}>
          {/* LEFT IMAGE */}
          <View style={styles.leftImage}>
            {/* <Image src={profileImg} style={styles.profileImage} /> */}
            {/* <Image src={headerImage} style={styles.profileImage} /> */}
            <Image
              src={`https://cubixweberp.com:229/BONDTIME_EMP_IMG/CBX002_time_133966086526123681.jpg`}
              style={styles.profileImage}
            />
            {/* <Image
              src="https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg"
              style={styles.profileImage}
            /> */}
          </View>

          {/* RIGHT DETAILS */}
          <View style={styles.rightInfo}>
            <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>
              {d.FistName} {d.MiddleName} {d.LastName}
            </Text>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Employee ID:</Text>
              <Text style={styles.value}>{d.EmpId}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Alternate ID:</Text>
              <Text style={styles.value}>{d.AlternateID}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Department:</Text>
              <Text style={styles.value}>{d.Department}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Job Title:</Text>
              <Text style={styles.value}>{d.JobTitle}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Join Date:</Text>
              <Text style={styles.value}>{formatDate(d.JoinDate)}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Status:</Text>
              <Text style={styles.value}>{d.Status}</Text>
            </View>
          </View>
        </View>

        {/* <View style={styles.divider} /> */}

        {/* PERSONAL INFO */}
        <Text style={styles.sectionTitle}>Personal Information</Text>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Gender:</Text>
          <Text style={styles.value}>{d.Gender}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Height:</Text>
          <Text style={styles.value}>{d.Height}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>DOB:</Text>
          <Text style={styles.value}>{formatDate(d.DOB)}</Text>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Nationality:</Text>
          <Text style={styles.value}>{d.Nationality}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Weight:</Text>
          <Text style={styles.value}>{d.Weight}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Marital:</Text>
          <Text style={styles.value}>{d.MaritalStatus}</Text>
        </View>

        <View style={styles.divider} />
        {/* CONTACT */}
        <Text style={styles.sectionTitle}>Contact Details</Text>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Personal Mobile:</Text>
          <Text style={styles.value}>{d.PersonalMobile}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Work Mobile:</Text>
          <Text style={styles.value}>{d.PersonalMobile}</Text>
        </View>
        <View style={styles.infoRow}>
          <Text style={styles.label}>Email:</Text>
          <Text style={styles.value}>{d.PersonalEmail}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Work Email:</Text>
          <Text style={styles.value}>{d.PersonalEmail}</Text>
        </View>
        <View style={styles.infoRow}>
          <Text style={styles.label}>Home Airport:</Text>
          <Text style={styles.value}>{d.PersonalEmail}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Home Address:</Text>
          <Text style={styles.value}>{d.PersonalEmail}</Text>
        </View>

        <View style={{ marginTop: 5 }}>
          <Text style={styles.label}>Current Address:</Text>
          <Text style={styles.value}>{d.CurrentAddress}</Text>

         
        </View>
        <View style={styles.divider} />

        {/* SALARY */}
        <Text style={styles.sectionTitle}>Salary Details</Text>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Basic Pay:</Text>
          <Text style={styles.value}>{d.BasicPay}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Net Salary:</Text>
          <Text style={styles.value}>{d.NetSalary}</Text>
        </View>

        <View style={styles.divider} />

        {/* DOCUMENTS */}
        <Text style={styles.sectionTitle}>Documents</Text>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Passport No:</Text>
          <Text style={styles.value}>{d.PassportNo}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Expiry:</Text>
          <Text style={styles.value}>{formatDate(d.PassportExpiryDate)}</Text>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Emirates ID:</Text>
          <Text style={styles.value}>{d.EmiratesId}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Expiry:</Text>
          <Text style={styles.value}>{formatDate(d.EmiratesIdExpiryDate)}</Text>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Visa No:</Text>
          <Text style={styles.value}>{d.VisaNo}</Text>

          <Text style={[styles.label, { marginLeft: 20 }]}>Expiry:</Text>
          <Text style={styles.value}>{formatDate(d.VisaExpiryDate)}</Text>
        </View>

        <View style={styles.divider} />

        {/* FOOTER */}
        {footerImage && (
          <Image
            src={footerImage}
            style={{
              position: "absolute",
              bottom: 10,
              width: "100%",
              height: 50,
            }}
          />
        )}
      </Page>
    </Document>
  );
};

export default EditEmpDocument;
